import { render, staticRenderFns } from "./HeaderOfferTrade.vue?vue&type=template&id=435c0608&scoped=true"
import script from "./HeaderOfferTrade.vue?vue&type=script&lang=js"
export * from "./HeaderOfferTrade.vue?vue&type=script&lang=js"
import style0 from "./HeaderOfferTrade.vue?vue&type=style&index=0&id=435c0608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c0608",
  null
  
)

export default component.exports